import { forwardRef } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

const SelectField = forwardRef(function SelectField({ label, error, options = [], className = "", ...props }, ref) {
  return (
    <label className="block text-left">
      {label ? <span className="mb-1.5 block text-sm font-semibold text-brand-ink">{label}</span> : null}
      <span className="relative block">
        <select
          ref={ref}
          className={cn(
            // WHY text-base on mobile: iOS Safari zooms the page on focus when
            // a field is under 16px; sm:text-sm keeps the desktop look.
            "w-full appearance-none rounded-xl border bg-white px-4 py-2.5 pr-10 text-base text-brand-ink outline-none transition focus:border-brand-primary focus:ring-2 focus:ring-brand-primary/20 sm:text-sm",
            error ? "border-red-500 focus:border-red-500 focus:ring-red-500/20" : "border-slate-200",
            className
          )}
          {...props}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <ChevronDown size={16} className="pointer-events-none absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
      </span>
      {error ? <span className="mt-1 block text-xs font-semibold text-red-600">{error}</span> : null}
    </label>
  );
});

export default SelectField;
